/**
 * @generated SignedSource<<6801b6d01c827878dd8f0e87bb0107af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addCollageRulePanel_AssignProductMutation$variables = {
  gridRuleId: string;
  productIds?: ReadonlyArray<number> | null;
};
export type addCollageRulePanel_AssignProductMutation$data = {
  readonly assignProductsToGridRule: {
    readonly result: string | null;
  } | null;
};
export type addCollageRulePanel_AssignProductMutation = {
  response: addCollageRulePanel_AssignProductMutation$data;
  variables: addCollageRulePanel_AssignProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "gridRuleId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "gridRuleId",
        "variableName": "gridRuleId"
      },
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      }
    ],
    "concreteType": "GridRuleResponse",
    "kind": "LinkedField",
    "name": "assignProductsToGridRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addCollageRulePanel_AssignProductMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addCollageRulePanel_AssignProductMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "427db0989b3aeb6f96e7c3fe0ba065e8",
    "id": null,
    "metadata": {},
    "name": "addCollageRulePanel_AssignProductMutation",
    "operationKind": "mutation",
    "text": "mutation addCollageRulePanel_AssignProductMutation(\n  $gridRuleId: ID!\n  $productIds: [Long!]\n) {\n  assignProductsToGridRule(gridRuleId: $gridRuleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "e564e54eb8c7bbeff5e5d21c841ad61f";

export default node;
